import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  cursor: pointer;

  ${(p) => p.theme.activeControlStyle}
`;

export const Control = styled.select`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  opacity: 0;
  appearance: none;
  cursor: inherit;
`;

export const Placeholder = styled.div`
  color: ${(p) => p.theme.yellow};
`;
